import get from 'lodash/get';
import {useState} from 'react';
import _ from "lodash";

import EditIcon from '@mui/icons-material/Edit';
import IconButton from '@mui/material/IconButton';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

import {formatPatientStatus} from '../../helpers/patients';
import {getPatientStatusOptions} from "./PatientStatusFilter";

const PatientStatus = props => {
  const {patient} = props;
  const status = get(props, 'patient.patient_status.status') || '';
  const [editorIsOpen, setEditorIsOpen] = useState(false);
  if (!patient) return null;
  const {color, Icon} = getPatientStatusOptions(_.camelCase(status));
  const body = formatPatientStatus(patient);
  return (
    status && <Stack direction='row' spacing={1} alignItems='center'>
      <Icon style={{color, fontSize: '1em'}}/>
      <Typography
        variant='body1'
        color='grey'
        style={{fontSize: '1em'}}
      >
        {body}
      </Typography>
      {
        props.isEditable
        ? <IconButton
          onClick={() => editorIsOpen(true)}
        >
          <EditIcon/>
        </IconButton>
        : null
      }
    </Stack>
  );
};

export default PatientStatus;
